// extracted by mini-css-extract-plugin
export var growableInput = "_7r-0";
export var tagContainer = "_7r-2";
export var textInput = "_7r-1";